export default "./dist/stdassets/images/icons/theme.png";